import { isEmpty } from '@sgme/fp';
import { SummaryFieldRow } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/SummaryFieldRow';
import { LinksValueDefinition } from 'models/metadata/readonlyValue.definition';
import { FC } from 'react';
import { connect } from 'react-redux';
import type { IRegulatoryResource } from 'state/regulatoryDocuments';
import { getQuoteRegulationInfos } from 'state/selectors';
import type { AppState } from 'state/state.model';
import { getWorkspaceActiveTabId } from 'state/workspaces/workspaces/workspaces.selector';

interface OwnProps {
  node: LinksValueDefinition;
}

interface StateProps {
  kidDocuments: IRegulatoryResource[] | undefined;
  pgDocuments: IRegulatoryResource[] | undefined;
}

export type ProductSummaryLinksListState = OwnProps & StateProps;

const mapStateToProps = (state: AppState): StateProps => {
  const currentTabId = getWorkspaceActiveTabId(state, 'static')!;
  const metaData = getQuoteRegulationInfos(state, 'static', currentTabId)!;
  const kidDocuments = metaData.kidDocument;
  const pgDocuments = metaData.productGovernanceDocumentation;
  return {
    kidDocuments,
    pgDocuments,
  };
};

export const connectProductSummaryLinksListField = connect(mapStateToProps);

export const Component: FC<ProductSummaryLinksListState> = ({ node, kidDocuments, pgDocuments }) => {
  const documents = documentsForId(node.id, kidDocuments, pgDocuments);
  const translationKey = node.translationKey ?? node.id;

  return (
    <SummaryFieldRow labelKey={translationKey} id={node.id}>
      {isEmpty(documents) ? (
        <p className="text-large fw-light m-0" data-e2e={`product-summary-field-${node.id}`}>
          <table className="table table-borderless text-start mb-1">
            <tbody>
              <tr className="m-0 fw-light" data-e2e="document-row">
                <td data-e2e="link">N/A</td>
              </tr>
            </tbody>
          </table>
        </p>
      ) : (
        <p className="text-large fw-light m-0" data-e2e={`product-summary-field-${node.id}`}>
          <table className="table table-borderless text-start mb-1">
            <tbody>
              {documents.map(document => (
                <tr key={document.uri} className="m-0 fw-light" data-e2e="document-row">
                  <td data-e2e="link">
                    <a href={document.uri} target="_blank">
                      {document.language}
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </p>
      )}
    </SummaryFieldRow>
  );
};

export function documentsForId(
  id: string,
  kidDocuments: IRegulatoryResource[] | undefined,
  pgDocuments: IRegulatoryResource[] | undefined,
) {
  switch (id) {
    case 'KidDocuments':
      return kidDocuments;
    case 'PgDocuments':
      return pgDocuments;
    default:
      return undefined;
  }
}

Component.displayName = 'ProductSummaryLinksListField';
export const ProductSummaryLinksListField = connectProductSummaryLinksListField(Component);
